// extracted by mini-css-extract-plugin
export default {"ctn":"battery_ctn__ffNr-","textBox":"battery_textBox__LEI+L","paramsBox":"battery_paramsBox__h4+IS","line":"battery_line__7czOt"};